export enum PackageToCustomerStepState
{
    NotPlannedYet = "NotPlannedYet",
    Planned = "Planned",
    LabelReady = "LabelReady",
    ReadyToShipment = "ReadyToShipment",
    InTransit = "InTransit",
    Delivered = "Delivered",
    Problem = "Problem",
    NotDeliveredYet = "NotDeliveredYet",
    Cancelled = "Cancelled",
    RejectedByCustomer = "RejectedByCustomer",
    PackageLost = "PackageLost",
    AwaitingInPostOffice = "AwaitingInPostOffice",
    StillOnTheWay = "StillOnTheWay",
    PackageReturned = "PackageReturned",
}
